export const registrationCountries = [
  "United States", "China", "India", "Brazil", "Russia", "United Kingdom", "France", "Germany", "Japan", "South Korea",
  "Canada", "Australia", "Mexico", "South Africa", "Argentina", "Saudi Arabia", "Spain", "Italy", "Netherlands", "Turkey",
  "Indonesia", "Pakistan", "Nigeria", "Egypt", "Bangladesh", "Vietnam", "Philippines", "Thailand", "Colombia", "Chile",
  "Nigeria", "Ethiopia", "Egypt", "DR Congo", "South Africa", "Tanzania", "Kenya", "Uganda", "Algeria", "Sudan", "Morocco",
];
